import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import {
  CreateSubscriberRequestSchema,
  CreateSubscriberResponseSchema,
  ListSubscribersQuerySchema,
  SubscribersListResponseSchema,
} from './schemas.js';

export const listQueryOptions = defaultClient.query({
  url: 'recommendations/notifications/subscribers' as const,
  method: 'GET',
  clientOptions: {
    request: {
      snakeCaseQueryParams: true,
    },
  },
  querySchema: ListSubscribersQuerySchema,
  responseSchema: SubscribersListResponseSchema,
  processResponse(data) {
    // The API does not guarantee item order, return items in creation order
    return [...(data.data?.items ?? [])].sort((a, b) => a.id - b.id);
  },
});

export const create = defaultClient.mutation({
  url: 'recommendations/notifications/subscribers' as const,
  method: 'POST',
  requestSchema: CreateSubscriberRequestSchema,
  responseSchema: CreateSubscriberResponseSchema,
  processResponse(data) {
    return data.data?.items[0];
  },
  onSuccess: (queryClient) => listQueryOptions.invalidateAll(queryClient, {}),
});

export const remove = defaultClient.mutation({
  url: 'recommendations/notifications/subscribers/$id' as const,
  method: 'DELETE',
  responseSchema: z.unknown(),
  onSuccess: (queryClient) => listQueryOptions.invalidateAll(queryClient, {}),
});
